module.exports = __webpack_public_path__ + "static/media/animal.767f5f61.svg";